module.exports = __webpack_public_path__ + "static/media/shannirmala.46552011.jpg";